import OutsideClick from "../OutsideClick";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./style.css";
import { HeaderCloseIcon } from "../GlobalIcons";
const CustomModal = ({ children, closeFunc, closeFuncState, id, cartPopUp, offOutSideClick, disableBackGroundScroll }) => {
  const modalRef = useRef();

  const closeModal = () => {
    closeFunc(closeFuncState);
    document.body.style.overflow = "auto";
  };


  useEffect(() => {
    if (disableBackGroundScroll) {
      document.body.style.overflow = "hidden";
    }
  }, [disableBackGroundScroll]);

  return createPortal(
    <>
      <div className={`custom-modal ${"show"}`} id={id} r>
        <div className={`modal-content ${cartPopUp ? "cartModal" : ""}`} ref={modalRef} >
          <button className="close-button" onClick={closeModal}>
            <HeaderCloseIcon />
          </button>
          <div className="modal-body">{children}</div>
        </div>
      </div>
      {
        !offOutSideClick &&

        <OutsideClick
          closeRef={modalRef}
          func={closeModal}
        />

      }
    </>,
    document.getElementById("modal")
  );
};

export default CustomModal;
